import { render, staticRenderFns } from "./cargoInquiry.vue?vue&type=template&id=f806888e&scoped=true"
import script from "./cargoInquiry.vue?vue&type=script&lang=js"
export * from "./cargoInquiry.vue?vue&type=script&lang=js"
import style0 from "./cargoInquiry.vue?vue&type=style&index=0&id=f806888e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f806888e",
  null
  
)

export default component.exports